export default {
  namespaced: true,
  state: {
    flags: [],
    count: 0,
  },
  getters: {
    flags: (state) => state.flags,
    count: (state) => state.count,
  },
  mutations: {
    flags: (state, payload) => (state.flags = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/flags", {
          params: queryParams,
        })
        .then((res) => {
          commit("flags", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("/flags", payload);
    },
    createTags({}, payload) {
      return this.$apiService.post("/create-flags", payload);
    },
    show({}, id) {
      return this.$apiService.get(`/flags/${id}`);
    },
    update({}, { id, data }) {
      return this.$apiService.put(`/flags/${id}`, data);
    },
    destroy({}, id) {
      return this.$apiService.delete(`/flags/${id}`);
    },
  },
};
